import {Para, ParaProps} from "@/components/common/Para";

export function Span(props: ParaProps) {
    const { children, ...rest } = props;
    return (<Para span {...rest}>{children}</Para>);
}
